/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const DOCUMENT_ENTRY_INVENTORY = 'ELE'
export const DOCUMENT_EXIT_INVENTORY = 'ELS'
export const DOCUMENT_LEASE = 'BDL'
export const DOCUMENT_NOTICE = 'PDS'

export const LeaseDocumentTypeCodes = [
  DOCUMENT_ENTRY_INVENTORY,
  DOCUMENT_EXIT_INVENTORY,
  DOCUMENT_LEASE
]
